import { SetStateAction, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { filtersHookType, filterObjectType } from 'pages/resource-hub/types';
import { EVENTS_URL, RESOURCE_HUB_URL } from 'modules/utils/constants';
import { useSelectedFiltersURL } from './useSelectedFiltersURL';

export const useSelectedFiltersItems = (
  filters: filtersHookType,
  slug: string,
) => {
  const [topicsSlug, setTopicsSlug] = useState('');
  const [bestPracticesSlug, setBestPracticesSlug] = useState('');
  const [contentTypesSlug, setContentTypesSlug] = useState('');
  const [pathSlug, setPath] = useState<string[]>([]);
  const history = useHistory();
  let newArr: SetStateAction<string[]> = [];
  const {
    addDeleteFilterItem,
    refreshResults,
    setRefreshResults,
    selectItemsFromSlug,
  } = useSelectedFiltersURL(slug);

  const path = window.location.href.includes('/resource-hub')
    ? RESOURCE_HUB_URL
    : EVENTS_URL;

  const updateTopicsURL = useCallback(
    (newTopicsURL: string) => {
      let newURL = '';

      if (newTopicsURL !== '') {
        newURL = `${newTopicsURL}/`;
      }

      if (bestPracticesSlug !== '') {
        newURL = `${newURL}${bestPracticesSlug}/`;
      }

      if (contentTypesSlug !== '') {
        newURL = `${newURL}${contentTypesSlug}/`;
      }
      setTopicsSlug(newTopicsURL);
      //history.push(`${path}${newURL}`);
      newArr = [];
      newArr.push(newTopicsURL);
      localStorage.removeItem('setTopicsSlug');
      localStorage.setItem('setTopicsSlug', newArr.join(','));
    },
    [bestPracticesSlug, contentTypesSlug, history],
  );

  const updateBestPracticesURL = useCallback(
    (newBestPracticesURL: string) => {
      let newURL = '';
      if (topicsSlug !== '') {
        newURL = `${topicsSlug}/`;
      }

      if (newBestPracticesURL !== '') {
        newURL = `${newURL}${newBestPracticesURL}/`;
      }

      if (contentTypesSlug !== '') {
        newURL = `${newURL}${contentTypesSlug}/`;
      }
      setBestPracticesSlug(newBestPracticesURL);
      newArr = [];
      newArr.push(newBestPracticesURL);
      localStorage.removeItem('setBestPracticesSlug');
      localStorage.setItem('setBestPracticesSlug', newArr.join(','));
    },
    [contentTypesSlug, history, topicsSlug],
  );

  const updateContentTypesURL = useCallback(
    (newContentTypesURL: string) => {
      let newURL = '';

      if (topicsSlug !== '') {
        newURL = `${topicsSlug}/`;
      }
      if (bestPracticesSlug !== '') {
        newURL = `${newURL}${bestPracticesSlug}/`;
      }
      if (newContentTypesURL !== '') {
        newURL = `${newURL}${newContentTypesURL}/`;
      }
      newArr = [];
      newArr.push(newContentTypesURL);
      setContentTypesSlug(newContentTypesURL);
      localStorage.removeItem('setContentTypesSlug');
      localStorage.setItem('setContentTypesSlug', newArr.join(','));
      //history.push(`${path}`);
    },
    [bestPracticesSlug, history, topicsSlug],
  );

  function revertSlug(slug: string) {
    if (!slug || slug.trim() === '') return '';

    // Convert dashes to spaces
    let reverted = slug.replace(/-/g, ' ');

    // Replace 'and' with '&' (whole word only, case-insensitive)
    reverted = reverted.replace(/\band\b/gi, '&');

    // Capitalize the first letter of each word
    const words = reverted.split(' ').filter(Boolean);
    const capitalized = words.map(
      (word: string) => word.charAt(0).toUpperCase() + word.slice(1),
    );

    return capitalized.join(' ');
  }

  const getFilterObjectsFromLocalStorage = (
    slug: string,
  ): filterObjectType[] => {
    const stored = localStorage.getItem(slug);
    if (!stored) return [];

    const titles = stored.split(',').map(t => t.trim());

    const filterObjects: filterObjectType[] = titles.map((title, index) => ({
      title: revertSlug(title),
      slug: revertSlug(title),
      uid: '',
      colour: '', // cycle through colors
    }));

    return filterObjects;
  };

  const addDeleteCategory = useCallback(
    (item: filterObjectType) => {
      addDeleteFilterItem(
        item,
        filters.setContentTypesSelected,
        getFilterObjectsFromLocalStorage('setContentTypesSlug'),
        updateContentTypesURL,
      );
    },
    [
      addDeleteFilterItem,
      filters.setContentTypesSelected,
      filters.contentTypesSelected,
      updateContentTypesURL,
    ],
  );

  const addDeleteResourceType = useCallback(
    (item: filterObjectType) => {
      addDeleteFilterItem(
        item,
        filters.setTopicsSelected,
        getFilterObjectsFromLocalStorage('setTopicsSlug'),
        updateTopicsURL,
      );
    },
    [
      addDeleteFilterItem,
      filters.setTopicsSelected,
      filters.topicsSelected,
      updateTopicsURL,
    ],
  );

  const addDeleteCertificate = useCallback(
    (item: filterObjectType) => {
      addDeleteFilterItem(
        item,
        filters.setBestPracticesSelected,
        getFilterObjectsFromLocalStorage('setBestPracticesSlug'),
        updateBestPracticesURL,
      );
    },
    [
      addDeleteFilterItem,
      filters.bestPracticesSelected,
      filters.setBestPracticesSelected,
      updateBestPracticesURL,
    ],
  );

  return {
    addDeleteResourceType,
    addDeleteCertificate,
    addDeleteCategory,
    refreshResults,
    selectItemsFromSlug,
    setBestPracticesSlug,
    setContentTypesSlug,
    setRefreshResults,
    setTopicsSlug,
  };
};
